import { createContext } from 'react'

const editSurveyContext = createContext({
    /*
    ** 설문 에디트 
    */
    editOpen: false,
})

export default editSurveyContext